export default __webpack_public_path__ + "static/media/audio-icon.7c12186c.svg";